<div p-component>
  <p-menubar *ngIf="loggedIn" [model]="menuItems" [autoDisplay]="true"
    [ngClass]="{'fixed-menu': isMenuFixed}" data-testid="main-nav">
    <ng-template pTemplate="end">
      <div class="navbar-end-controls">
        <div class="navbar-store-env navbar-desktop-only">
          <span class="store-env-label">Store Env:</span>
          <environment-toggler></environment-toggler>
        </div>

        <div class="navbar-divider navbar-desktop-only"></div>

        <button pButton pRipple icon="pi pi-list" type="button"
          pTooltip="Content Issues" tooltipPosition="bottom"
          class="p-button-rounded p-button-text-title navbar-desktop-only"
          routerLink="/content-issues"></button>

        <div class="cart-wrapper navbar-desktop-only">
          <button pButton pRipple icon="pi pi-shopping-cart" type="button"
            class="p-button-rounded p-button-text-title cart-button"
            (click)="toggleTransferModal()"></button>
          <p-badge [value]="storeTransferCount" severity="primary" size="small"></p-badge>
        </div>

        <notification-bell class="navbar-desktop-only"></notification-bell>

        <global-search></global-search>

        <div class="navbar-divider"></div>

        <button pButton pRipple icon="pi pi-bars" type="button"
          pTooltip="Menu" tooltipPosition="bottom"
          class="p-button-rounded p-button-text-title"
          (click)="toggleSidebar()"></button>

        <p-sidebar [(visible)]="sidebarVisible" [showCloseIcon]="true" [closeOnEscape]="true" position="right" appendTo="body">
          <app-side-menu
            [storeTransferCount]="storeTransferCount"
            (transferModalRequested)="onSidebarTransferModal()"
            (closeRequested)="sidebarVisible = false">
          </app-side-menu>
        </p-sidebar>
      </div>
    </ng-template>
  </p-menubar>
  <p-toast [life]="3000"></p-toast>
  <router-outlet></router-outlet>

  <app-report-issue [(visible)]="reportIssueVisible"></app-report-issue>
</div>
<p-dialog [(visible)]="transferModalVisible" [dismissableMask]="true" [modal]="true" [transitionOptions]="'200ms'"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '90vw' }" (onShow)="reloadCart()"
  maximizable="true">
  <ng-template pTemplate="header">
    <div class="header-content">
      <h3>Store Transfer</h3>
    </div>
  </ng-template>
  <div>
    <store-transfer (enableButton)="setEnableTransfer($event)" [sourceEnv]="cart ? cart.sourceEnv : 'dev'" [destinationEnv]="cart ? cart.destinationEnv : 'qa'" [storeListings]="cart ? cart.listings : []"
      [pricePoints]="cart ? cart.pricePoint : []"></store-transfer>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Transfer" [disabled]="enableTransfer" icon="pi pi-check" (click)="storeTransfer()"
      class="p-button-primary p-mt-3"></button>
    <button pButton type="button" label="Cancel" icon="pi pi-times" (click)="transferModalVisible = false"
      class="p-button-secondary p-mt-3"></button>
  </ng-template>
</p-dialog>
